import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { Type } from '../../../../base/Type/Type';
import { CompanyIntroStatCardStoryblok } from '../../../../types/storyblok';

export const CompanyIntroStatCard = ({
  stat,
  description,
}: CompanyIntroStatCardStoryblok) => {
  if (!stat && !description) {
    return null;
  }

  return (
    <Box
      as="li"
      className="flex flex-row border-r-2 pr-6 last:border-r-0 last:pr-0"
      border
    >
      <Type as="h3" className="mr-2 text-p1 font-bold">
        {stat}
      </Type>
      <Type as="h3" className="text-p1">
        {description}
      </Type>
    </Box>
  );
};
